var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { cursor: "pointer", "border-shadow": "1px" },
      on: {
        mouseover: function($event) {
          return _vm.changehover(true)
        },
        mouseleave: function($event) {
          return _vm.changehover(false)
        }
      }
    },
    [
      !_vm.onhover
        ? _c(
            "div",
            {
              staticClass: "container",
              on: {
                click: function($event) {
                  return _vm.gotolink(_vm.link)
                }
              }
            },
            [
              _c("v-img", {
                staticStyle: { "object-fit": "cover" },
                attrs: {
                  cover: "",
                  src: require("../assetsHome/isotipo_producto_" +
                    _vm.colorIsotipo +
                    ".png")
                }
              }),
              _c(
                "p",
                { style: [{ color: _vm.colorTexto, "text-align": "center" }] },
                [_vm._v("\n      " + _vm._s(_vm.titulo) + "\n    ")]
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "container",
              on: {
                click: function($event) {
                  return _vm.gotolink(_vm.link)
                }
              }
            },
            [
              _c("v-img", {
                staticStyle: { "object-fit": "cover" },
                attrs: {
                  cover: "",
                  src: require("../assetsHome/isotipo_producto_amarillo.png")
                }
              }),
              _c(
                "p",
                {
                  staticStyle: {
                    color: "#4169e1",
                    "font-family": "Asap",
                    "font-size": "10px",
                    width: "75px",
                    height: "40px",
                    "justify-content": "center",
                    "text-align": "center"
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.tituloHover) + "\n    ")]
              )
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }